import { render, staticRenderFns } from "./AddToInternalMovingMaterials.vue?vue&type=template&id=44afdb38&scoped=true"
import script from "./AddToInternalMovingMaterials.vue?vue&type=script&lang=js"
export * from "./AddToInternalMovingMaterials.vue?vue&type=script&lang=js"
import style0 from "./AddToInternalMovingMaterials.vue?vue&type=style&index=0&id=44afdb38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44afdb38",
  null
  
)

export default component.exports